import { useQuery } from "@tanstack/react-query";
import { previewInvite } from "@/adapters/api";

export function useInvitePreview(token: string | undefined) {
	return useQuery({
		queryKey: ["invite-preview", token],
		queryFn: () => previewInvite(token as string),
		enabled: token != null,
		retry: false,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});
}
